<template>
	<div style="height: 100%;">
  	<router-view></router-view>
	</div>
</template>

<script>
import ContentList from './content/List'
import ContentListEditor from './content/ListEditor'
import ContentListDataEditor from './content/ListDataEditor'
import ContentListDataImportEditor from './content/ListDataImportEditor'
import ContentListJsonDataImportEditor from './content/ListJsonDataImportEditor'
import ContentListDataMultiUploadEditor from './content/ListDataMultiUploadEditor'
import ContentListData from './content/DataSearch'


export default {
	routes: [
	  {
      path: '',
      redirect: '/content/list/default'
    },
    {
      path: "list/:id",
      name: "Content list",
      components: {
       sidebar: ContentList,
       default: ContentListData
     	},
      props: {
      	sidebar: true,
      	default: true,
      },
      meta: {showNavigationDrawer: true, search: false},
			children: [
				{
					path: "new",
					name: "New content list",
					components: {
						default: ContentList,
						bottomEditor: ContentListEditor
					},
					props: {
						default: true,
						bottomEditor: false
					}
				},
				{
					path: "edit",
					name: "Edit content",
					components: {
						default: ContentList,
						bottomEditor: ContentListEditor
					},
					props: {
						default: true,
						bottomEditor: true
					}
				},
				{
					path: "data/new",
					name: "New list data",
					components: {
						default: ContentList,
						bottomEditor: ContentListDataEditor
					},
					props: {
						default: true,
						bottomEditor: true
					}
				},
				{
					path: "data/edit/:data_id",
					name: "Edit list data",
					components: {
						default: ContentList,
						bottomEditor: ContentListDataEditor
					},
					props: {
						default: true,
						bottomEditor: true
					}
				},
				{
					path: "data/import",
					name: "Import list data",
					components: {
						default: ContentList,
						bottomEditor: ContentListDataImportEditor
					},
					props: {
						default: true,
						bottomEditor: true
					}
				},
				{
					path: "data/json_import",
					name: "Import json list data",
					components: {
						default: ContentList,
						bottomEditor: ContentListJsonDataImportEditor
					},
					props: {
						default: true,
						bottomEditor: true
					}
				},
				{
					path: "data/multi_upload",
					name: "Multi upload list data",
					components: {
						default: ContentList,
						bottomEditor: ContentListDataMultiUploadEditor
					},
					props: {
						default: true,
						bottomEditor: true
					}
				}

			]
    }

	],
	components: {
		ContentList
	},
	data () {
		return {

		}
	}
}
</script>
